import * as types from './mutations'
import Vue from 'vue'

const state = {
    live: {},
    staging: {},
    archived: {},
    currentStackedOffer: {},
    isDirty: false,
    redirect: {},
    allStackedOffers: {},
}

const mutations = {

    [types.FETCH_LIVE_STACKED_OFFERS] (state, data)
    {
        state.live = data
        state.isDirty = false
    },

    [types.FETCH_STAGING_STACKED_OFFERS] (state, data)
    {
        state.staging = data
        state.isDirty = false
    },

    [types.FETCH_ARCHIVED_STACKED_OFFERS] (state, data)
    {
        state.archived = data
        state.isDirty = false
    },

    [types.CLEAR_STACKED_OFFERS] (state)
    {
        state.live = {}
        state.staging = {}
        state.archived = {}
        state.isDirty = false
    },

    [types.SET_CURRENT_STACKED_OFFER] (state, offer)
    {
        state.currentStackedOffer = offer
        state.isDirty = false
    },

    [types.SET_DIRTY_STACKED_OFFER] (state, dirty)
    {
        state.isDirty = dirty
    },

    [types.SET_REDIRECT_STACKED_OFFER] (state, to)
    {
        state.redirect = to
    },

    [types.SET_ALL_STACKED_OFFERS] (state, data)
    {
        state.allStackedOffers = data
    },
}

const actions = {

    stackedOffersFetchLive({commit}, params)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get('/stackedoffers/live', { params: params })
                commit(types.FETCH_LIVE_STACKED_OFFERS, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOffersFetchStaging({commit}, params)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get('/stackedoffers/staging', { params: params })
                commit(types.FETCH_STAGING_STACKED_OFFERS, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOffersFetchArchived({commit}, params)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get('/stackedoffers/archived', { params: params })
                commit(types.FETCH_ARCHIVED_STACKED_OFFERS, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferFetchByUrl({commit}, url)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get(`/stackedoffers/url/${url}`)
                commit(types.SET_CURRENT_STACKED_OFFER, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferFetchById({commit}, id)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get(`/stackedoffers/${id}`)
                commit(types.SET_CURRENT_STACKED_OFFER, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferCreate({commit, dispatch}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.post(`/stackedoffers`, payload)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferUpdate({commit, dispatch}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.put(`/stackedoffers/${payload.id}`, payload)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferDelete({commit, dispatch}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.delete(`/stackedoffers/${payload.id}`)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferAction({dispatch}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const id = payload.ids.shift()
                const response = await Vue.axios.put(`/stackedoffers/${id}/${payload.action}`)
                if (payload.ids.length > 0)
                {
                    dispatch('stackedOfferAction', payload).then(res => {
                        resolve(response.data)
                    })
                } else {
                    resolve(response.data)
                }
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferReorder({dispatch}, query)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.put(`/stackedoffers/reorder`, query)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

    stackedOfferFormDirty({commit}, state)
    {
        commit(types.SET_DIRTY_STACKED_OFFER, state)
    },

    stackedOfferRedirectTo({commit}, to)
    {
        commit(types.SET_REDIRECT_STACKED_OFFER, to)
    },

    logout({commit})
    {
        commit(types.CLEAR_STACKED_OFFERS)
    },

    stackedOffersFetch({commit}, params)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.get('/stackedoffers')
                commit(types.SET_ALL_STACKED_OFFERS, response.data)
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    },

}

const getters = {
    stackedOffersLive: state => JSON.parse(JSON.stringify(state.live)),
    stackedOffersStaging: state => JSON.parse(JSON.stringify(state.staging)),
    stackedOffersArchived: state => JSON.parse(JSON.stringify(state.archived)),
    stackedOfferCurrent: state => JSON.parse(JSON.stringify(state.currentStackedOffer)),
    stackedOfferFormIsDirty: state => state.isDirty,
    stackedOfferRedirectTo: state => state.redirect,
    stackedOffersAll: state => JSON.parse(JSON.stringify(state.allStackedOffers)),
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/stackedoffers/index.js